"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var PromoCodeTemplatesList_1 = require("./component/PromoCodeTemplatesList");
var PromoCodeTemplateEditor_1 = require("./component/PromoCodeTemplateEditor");
var PromoCodeOperationsConfig_1 = require("./component/PromoCodeOperationsConfig");
var PPromoCodeTemplatesList = /** @class */ (function (_super) {
    __extends(PPromoCodeTemplatesList, _super);
    function PPromoCodeTemplatesList(props) {
        return _super.call(this, props) || this;
    }
    PPromoCodeTemplatesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AP = this.props.listPromoTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_promo_template_types: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            record: null,
            page_num: 1,
            logs_page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_promo_template_types: []
        }, function () {
            _this.props.listBrands.LoadData();
            _this.props.listPromoTypesAvail.LoadData();
        });
    };
    PPromoCodeTemplatesList.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_AB);
        this.props.listPromoTypesAvail.UnSubscribe(this.SID_AP);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PPromoCodeTemplatesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PPromoCodeTemplatesList.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", rootRecord: item });
    };
    PPromoCodeTemplatesList.prototype.onConfigClick = function (item) {
        this.setState({ edit_mode: "CONFIG", rootRecord: item });
    };
    PPromoCodeTemplatesList.prototype.onGoBackToListClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PPromoCodeTemplatesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PPromoCodeTemplatesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PPromoCodeTemplatesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PromoCodeTemplateEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackToListClick.bind(this), listBrands: this.props.listBrands, listAppCurrency: this.props.listAppCurrency, availPromoTemplateTypes: this.state.avail_promo_template_types, listAffilatesAvail: this.props.listAffilatesAvail, listAffilatesPartnersAvail: this.props.listAffilatesPartnersAvail, listAffilatesPartnersOffersAvail: this.props.listAffilatesPartnersOffersAvail, listAffilatesPartnersTrackersAvail: this.props.listAffilatesPartnersTrackersAvail, ListBonusLevelsAvail: this.props.ListBonusLevelsAvail, dialogSelectImage: this.props.dialogSelectImage, listPromoReActivations: this.props.listPromoReActivations, listDepositAges: this.props.listDepositAges }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PromoCodeTemplateEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackToListClick.bind(this), listBrands: this.props.listBrands, listAppCurrency: this.props.listAppCurrency, availPromoTemplateTypes: this.state.avail_promo_template_types, listAffilatesAvail: this.props.listAffilatesAvail, listAffilatesPartnersAvail: this.props.listAffilatesPartnersAvail, listAffilatesPartnersOffersAvail: this.props.listAffilatesPartnersOffersAvail, listAffilatesPartnersTrackersAvail: this.props.listAffilatesPartnersTrackersAvail, ListBonusLevelsAvail: this.props.ListBonusLevelsAvail, dialogSelectImage: this.props.dialogSelectImage, listPromoReActivations: this.props.listPromoReActivations, listDepositAges: this.props.listDepositAges }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(PromoCodeOperationsConfig_1.default, { state: this.props.state, rootRecord: this.state.rootRecord, onGoBackClick: this.onGoBackToListClick.bind(this), dlgSelectBonusTemplate: this.props.dlgSelectBonusTemplate, dlgDescriptionEditor: this.props.dlgDescriptionEditor, listPromoBonusesTemplatesAvail: this.props.listPromoBonusesTemplatesAvail, dataBonuses: this.props.dataPromoTypeBonuses, dataLocales: this.props.dataPromoCodeLocale, listAppLanguages: this.props.listAppLanguages, dataCountries: this.props.dataPromoCodeCountries, listAppCountries: this.props.listAppCountry, dataPromoCodes: this.props.dataPromoTypeCodes, dataLogs: this.props.dataPromoTypeCodesLogs, dlgGeneratePromoCode: this.props.dlgGeneratePromoCode, glgGenerateOnePromoCode: this.props.dlgGenerateOnePromoCode, dialogSetPromoPartner: this.props.dialogSetPromoPartner, dataPromoTypeAmounts: this.props.dataPromoTypeAmounts, listAppCurrency: this.props.listAppCurrency, dlgPromoCodeExpiration: this.props.dlgPromoCodeExpiration, dlgExport: this.props.dlgExport }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PromoCodeTemplatesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onConfigClick.bind(this), dlgDescriptionEditor: this.props.dlgDescriptionEditor }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PPromoCodeTemplatesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PPromoCodeTemplatesList.getPageDescription = function (state) {
        return {
            icon: "barcode",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_promocodes + "-id",
            itemTitle: "Промокоды",
            route: routes_1.routes.page_gift_promocodes,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PPromoCodeTemplatesList;
}(React.Component));
exports.default = PPromoCodeTemplatesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/PPromoCodeTemplatesList.tsx
// module id = 1958
// module chunks = 0